<template>
  <div>
    <b-nav tabs>
      <b-nav-item v-bind:active="currentTab && currentTab === 'requirements'" v-show="selectedProject" @click="pushTheState('requirements')">Requirements</b-nav-item>
      <b-nav-item v-bind:active="currentTab && currentTab === 'traceability'" v-show="selectedProject" @click="pushTheState('traceability')">Traceability Matrix</b-nav-item>
      <b-nav-item v-bind:active="currentTab && currentTab === 'baselines'" v-show="selectedProject" @click="pushTheState('baselines')">Baselines</b-nav-item>
      <div id="project-selection">
        <b-form-select v-model="selectedProject"
                       :options="projectsArray">
        </b-form-select>
      </div>
      <div v-if="currentProjectIsGlobal" v-b-tooltip.hover title="Global Requirements is a special project automatically created for you that allows you to link to issues across your whole Jira instance (not just within a single project)"><icon id="global-icon" name="info-circle"></icon></div>
    </b-nav>
  </div>
</template>

<script>
  import utilsMixin from '@/mixins/utils'
  export default {
    mixins: [utilsMixin],
    data () {
      return {
        selectedProject: null
      }
    },
    mounted () {
      this.selectedProject = this.currentProject
      this.backupResizeToParentInCaseAuthViewOneFails()
    },
    watch: {
      currentProject (newValue, oldValue) {
        // Only make changes to selectedProject if the project was actually changed. This is for when going back/forward in browser
        if (this.selectedProject && newValue) {
          if (this.selectedProject.id.toString() !== newValue.id.toString()) {
            // Now update the current project in the dropdown
            this.selectedProject = this.projects[newValue.id.toString()]
          }
        } else if (!this.selectedProject) {
          this.selectedProject = this.projects[newValue.id.toString()]
        }
      },
      selectedProject (newValue, oldValue) {
        // First check  if this was triggered by the currentProject watch, which is mainly meant for back/forward browser
        // movement, and making sure the project is kept up to date.
        const currentState = window.AP.history.getState()
        if (!currentState) {
          console.log('No current state in selectedProject')
          return
        }
        let itemParams = currentState.split('-')
        if (!oldValue && (this.currentProject && newValue && this.currentProject.id.toString() === newValue.id.toString())) {
          window.AP.history.pushState(currentState)
        } else if (!oldValue || (this.currentProject && newValue && this.currentProject.id.toString() !== newValue.id.toString())) {
          // Get the current state, replace the first item with the new current project id
          itemParams[0] = newValue.id
          // Remove the last part of the array (individual requirement/baseline/folder id), because project is changing
          itemParams = itemParams.slice(0, 2)
          window.AP.history.pushState(itemParams.join('-'))
        }
      }
    },
    computed: {
      currentProject () {
        return this.$store.state.currentProject
      },
      currentProjectIsGlobal () {
        return this.currentProject && this.currentProject.id === 0
      },
      currentTab () {
        return this.$store.state.currentTab
      },
      projects () {
        return this.$store.state.projects
      },
      projectsArray () {
        return this.$store.state.projectsArray
      }
    },
    methods: {
      pushTheState (location) {
        window.AP.history.pushState(`${this.currentProject.id}-${location}`)
      }
    }
  }
</script>

<style>
  #project-selection {
    padding-left: 10px;
  }
  #global-icon {
    margin: 10px;
    color: green;
  }
</style>



// WEBPACK FOOTER //
// AppNav.vue?25f9f82e